<template>
  <v-container v-if="!!data"
               fill-height
               fluid
               pa-0
               style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%); position: relative;"
  >
    <v-row class="fill-height white--text" justify="center" no-gutters>
      <animation id="confetti"
                 v-model="shouldPlay"
                 :autoplay="false"
                 :data="require('@/assets/lottie/achievement_confetti_cannon.json')"
                 sound="@/assets/sounds/rvtdc.wav"
                 style="width: 350px; position: absolute; top: -200px; transition: opacity 0.3s;"
      ></animation>
      <top-bar>
        <template v-slot:logos>
          <v-row class="fill-height pt-6 pl-6" no-gutters>
            <v-col class="flex-shrink-1 pr-4" cols="auto">
              <v-img max-width="115" src="@/assets/logos/fitt_logo.svg"></v-img>
            </v-col>
<!--            <v-col class="flex-shrink-1 " cols="auto">-->
<!--              <v-img contain max-width="150" src="@/assets/logos/psychai_logo.png"></v-img>-->
<!--            </v-col>-->
          </v-row>
        </template>
        <template v-slot:title>{{ data.title }}</template>
        <template v-slot:info>
          <v-row class="pt-8 pr-4" justify="end" no-gutters>
            <v-btn dark icon x-large @click="$router.replace(`/${$route.params.app}/menu`)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </template>
      </top-bar>
      <v-col v-if="!!data" cols="12" style="transform: translateY(-80px);">
        <v-row align="center" class="flex-nowrap" no-gutters>
          <div v-for="(item, index) in data.items"
               :id="'item_'+index"
               :key="index"
               :style="{ 'min-width': itemMaxWidth+'%', 'max-width': itemMaxWidth+'%', transform: index % 2 ? 'translateY(120px)' : '' }"
               style="position: relative; height: 100px;"
          >
            <v-row class="fill-height" justify="center" no-gutters>
              <v-avatar v-if="progress >= 6 && (index*itemMaxWidth) <= progress"
                        :style="{ bottom: index % 2 ? '-90px' : '',
                                  top: index % 2 ? '' : '-90px',
                                  'box-shadow': progress === (index*itemMaxWidth)+6 || progress >= 99 ? '0 0 10px 2px #FFFFFF' : '0 0 0 2px rgba(255,255,255,0.3)'}"
                        min-height="30"
                        min-width="30"
                        style="position: absolute;"
              >
                <animation v-if="progress === (index*itemMaxWidth)+6"
                           :data="require('@/assets/lottie/star.json')"
                           loop
                           sound="@/assets/sounds/rvtdc.wav"
                           style="position: absolute; max-width: 71px; min-width: 71px; max-height: 71px; min-height: 71px;"
                ></animation>
                <v-img v-else contain height="30" src="@/assets/icons/star.svg" width="30"></v-img>
              </v-avatar>
              <small :class="progress === (index*itemMaxWidth)+6 ? 'glow' : ''"
                     :style="{ bottom: index % 2 ? '-30px' : '', top: index % 2 ? '' : '-30px' }"
                     class="font-weight-bold text-center"
                     style="position: absolute; line-height: 1.2;"
              >{{ item.title }}
              </small>
              <div :style="{ 'border-bottom-right-radius': index % 2 ? '3px' : '',
                             'border-bottom-left-radius': index % 2 ? '3px' : '',
                             'border-top-right-radius': index % 2 ? '' : '3px',
                             'border-top-left-radius': index % 2 ? '' : '3px',
                             'background-color': progress >= 6 && (index*itemMaxWidth) <= progress ? 'white' : 'rgba(255,255,255,0.3)'}"
                   style="width: 7px; height: 100%; transition: background-color 4s ease"
              ></div>
            </v-row>
          </div>
        </v-row>
        <div class="progress-bar-main" style="position: relative;">
          <div :style="{ width: (progress+0.5)+'%' }" class="progress-bar-sub" style="position: absolute;">
            <div class="font-weight-bold ml-2" style="transform: translateY(-2px);">START</div>
          </div>
        </div>
      </v-col>
      <v-btn :disabled="progress === 0 || animating"
             absolute
             bottom
             color="rgba(255,255,255,0.3)"
             dark
             large
             right
             style="transform: translateX(-130px)"
             @click="back()"
      >Back
      </v-btn>
      <v-btn :disabled="nextDisabled || animating"
             absolute
             bottom
             color="rgba(255,255,255,0.3)"
             dark
             large
             right
             @click="next()"
      >Continue
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import roadmapData from '@/assets/text/roadmap_virtual_ghc.json'
import TopBar from "@/components/Framework/TopBar";
import Animation from "@/components/Framework/Animation";

export default {
  name: "RoadmapVirtualTdc",
  components: {
    TopBar,
    Animation
  },
  data: () => ({
    data: null,
    progress: 0,
    parsedItems: {
      even: [],
      odd: []
    },
    itemMaxWidth: 0,
    nextDisabled: false,
    shouldPlay: false,
    animating: false
  }),
  methods: {
    next() {
      this.animating = true;
      let max = this.itemMaxWidth * (parseInt(this.data.items.length) - 2);
      if (this.progress === 0) {
        this.progress = 6;
      } else if ((this.progress) > max) {
        this.progress = 100;
        this.nextDisabled = true;
      } else {
        this.progress += this.itemMaxWidth;
      }
      setTimeout(() => {
        this.animating = false;
      }, 4000);
      setTimeout(() => {
        document.getElementById('confetti').style.opacity = '0';
      }, 3700);
      setTimeout(() => {
        this.shouldPlay = true;
        setTimeout(() => {
          this.shouldPlay = false;
          document.getElementById('confetti').style.opacity = '1';
        }, 3000);
      }, 1000);
    },
    back() {
      this.animating = true;
      if (this.progress <= 6) {
        this.progress = 0;
      } else if (this.progress === 100) {
        this.progress = this.itemMaxWidth * (parseInt(this.data.items.length) - 2) + 6;
        this.nextDisabled = false;
      } else {
        this.progress -= this.itemMaxWidth;
        this.nextDisabled = false;
      }
      setTimeout(() => {
        this.animating = false;
      }, 4000)
    }
  },
  mounted() {
    this.data = roadmapData;
    this.itemMaxWidth = Math.floor(100 / parseInt(this.data.items.length));
  }
}
</script>

<style scoped>
.progress-bar-main {
  background-color: rgba(255, 255, 255, 0.3);
  height: 20px;
  width: 100%;
}

.progress-bar-sub {
  background-color: rgba(255, 255, 255, 0.5);
  height: 20px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  transition: width 4s ease;
}

.glow {
  -webkit-animation: glow 1s ease-in-out infinite alternate;
  -moz-animation: glow 1s ease-in-out infinite alternate;
  animation: glow 1s ease-in-out infinite alternate;
}

@-webkit-keyframes glow {
  from {
    text-shadow: 0 0 10px #fff;
  }
  to {
    text-shadow: 0 0 10px #fff;
  }
}
</style>